const checkHeight = () => {
    const header = document.querySelector('.theme-header header')
    const heroImage = document.querySelector('.wp-block-felix-fuchs-hero-image')
    if (header && heroImage) {
        const headerHeight = header.getBoundingClientRect().height
        heroImage.style.marginTop = `${headerHeight}px`
        heroImage.style.height = `calc(100vh - ${headerHeight}px)`
    }
}

const checkScroll = () => {
    const heroImage = document.querySelector('.wp-block-felix-fuchs-hero-image')
    if (heroImage) {
        const background = heroImage.querySelector('.background')
        background.style.top = `${window.scrollY * .4}px`
    }
}

window.addEventListener('load', () => {
    checkHeight()
    checkScroll()
})

window.addEventListener('scroll', checkScroll)